import { Matter } from '@/types';
import { HeaderTabLinks } from '@/components/ui/HeaderTabs';

interface MatterTabProps {
  activeTab: string;
  matter: Matter;
}

const MatterTab = ({ activeTab, matter }: MatterTabProps) => {
  const navigations = [
    {
      label: 'Settings',
      to: `/matter/${matter.guid}/settings`,
      active: activeTab === 'settings',
    },
    {
      label: 'Members',
      to: `/matter/${matter.guid}/members`,
      active: activeTab === 'members',
    },
    {
      label: 'Folder Syncing',
      to: `/matter/${matter.guid}/sync`,
      active: activeTab === 'sync',
    },
  ];

  return <HeaderTabLinks items={navigations} />;
};

export default MatterTab;
